function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import 'react';
import styled from 'styled-components';
import { theme } from '../../styles/theme.js';
import Flex from '../../Flex.js';
import { jsxs, jsx } from 'react/jsx-runtime';
function ModalHeader({
  title,
  close,
  center,
  noBorder
}) {
  return /*#__PURE__*/jsxs(Header, {
    align: "center",
    $centered: !!center,
    $noBorder: noBorder,
    children: [title && /*#__PURE__*/jsx(Title, {
      children: title
    }), close && /*#__PURE__*/jsx(CloseIcon, {
      onClick: close
    })]
  });
}
const Header = styled(Flex)`
  position: relative;
  height: 64px;
  padding: 0px ${theme.size.huge};
  border-bottom: ${p => p.$noBorder ? 'none' : theme.border.border};
  ${p => p.$centered && `justify-content: center;`};
`;
const Title = styled.span`
  position: relative;
  font-size: 18px;
  font-weight: 500;
  color: ${theme.color.text};
`;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CloseIcon = styled(props => /*#__PURE__*/jsx("svg", _objectSpread(_objectSpread({
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  viewBox: "0 0 20 20"
}, props), {}, {
  children: /*#__PURE__*/jsxs("g", {
    children: [/*#__PURE__*/jsx("polygon", {
      points: "18.096 19.174 19.497 17.747 1.7 .286 .3 1.714"
    }), /*#__PURE__*/jsx("polygon", {
      points: "19.497 1.714 18.096 .286 .3 17.747 1.7 19.174"
    })]
  })
})))`
  position: absolute;
  right: ${theme.size.huge};
  width: 18px;
  height: 18px;
  fill: ${theme.color.textLight};

  cursor: pointer;
  transition: fill 0.15s ease;

  &:hover {
    fill: ${theme.color.text};
  }
`;
export { ModalHeader };
//# sourceMappingURL=ModalHeader.js.map
